import STORE_CONST from '../consts'
import workGroupApi from '../../api/workgroup'

const state = {
	workgroup: {
		instances: [],
		databases: [],
		members: [],
	},
}

const mutations = {}

const actions = {
	[STORE_CONST.WORKGROUP.LIST_WORKGROUP_RESOURCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkGroupResource(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.LIST_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkGroupList(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.LIST_FAVOURITE_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getFavouriteWorkGroup(params).then(
				(res) => {
					resolve(res.data.objects)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.SET_FAVOURITE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.setFavourite(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_WORKGROUP_DETAIL]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkGroupDetail(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_TUNNEL_CODE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getTunnelCode(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取报告版本类型
	[STORE_CONST.WORKGROUP.GET_VERSION_BY_TYPE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getVersionByType(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 发起 诊断报告
	[STORE_CONST.WORKGROUP.CREATE_CSOS_REPORT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.createCsosReport(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取 诊断报告列表
	[STORE_CONST.WORKGROUP.GET_CSOS_REPORT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getCsosReport(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 查询月报更新状态
	[STORE_CONST.WORKGROUP.GET_CSOS_REPORT_STATE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getCsosReportState(params).then(
				(res) => {
					console.log(res, 'res')
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除工作组资源
	[STORE_CONST.WORKGROUP.DELETE_WORKGROUP]({ commit }, id) {
		return new Promise((resolve, reject) => {
			workGroupApi.delWorkGroupResource(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_CONNECT_LOG]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getConnectLog(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 创建工作组
	[STORE_CONST.WORKGROUP.CREATED_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi
				.createdWorkGroupResource(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	[STORE_CONST.WORKGROUP.GET_TUNNEL_INFO]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getTunnelInfo(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 测试主机账号密码连接
	[STORE_CONST.WORKGROUP.TEST_PASSWORD_CONNECTION]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.testPasswordConnection(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 修改工作组资源
	[STORE_CONST.WORKGROUP.PATCH_WORKGROUP]({ commit }, id) {
		return new Promise((resolve, reject) => {
			workGroupApi.patchWorkGroupResource(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.UPDATE_TUNNEL]({ commit }, params) {
		const data = {
			safe_mode: params.safe_mode,
		}
		return new Promise((resolve, reject) => {
			workGroupApi.updateTunnel(params.code, data).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除工作组资源
	[STORE_CONST.WORKGROUP.DEL_WORKGROUP_RESOURCE]({ commit }, ids) {
		return new Promise((resolve, reject) => {
			workGroupApi.batchDelWorkgroupResource(ids).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_PROJECT_RESOURCE_INFO]({ commit }, id) {
		return new Promise((resolve, reject) => {
			workGroupApi.getPeojectResourceInfo(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 添加工作组资源
	[STORE_CONST.WORKGROUP.ADD_WORKGTOUP_RESOURCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.addWorkgroupResource(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_CLIENT_IP]({ commit }) {
		return new Promise((resolve, reject) => {
			workGroupApi.getClientIp().then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取工作组成员列表
	[STORE_CONST.WORKGROUP.GET_MEMBER_LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkgroupMemberList(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 添加工作组成员
	[STORE_CONST.WORKGROUP.ADD_MEMBER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.addWorkgroupMember(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.CREATE_CODE]({ commit }, data) {
		return new Promise((resolve, reject) => {
			workGroupApi.createCode(data).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除工作组成员
	[STORE_CONST.WORKGROUP.DEL_MEMBER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.delWorkGroupMember(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取工作组群组
	[STORE_CONST.WORKGROUP.GET_WORKGROUP_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkgroupGroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取工作组群组列表
	[STORE_CONST.WORKGROUP.GET_GROUP_LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkgroupGroupList(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 添加工作组群组
	[STORE_CONST.WORKGROUP.ADD_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.addWorkgroupGroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 修改可登录用户
	[STORE_CONST.WORKGROUP.CHANGE_LOGIN_USER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.changeLoginUser(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除工作组群组
	[STORE_CONST.WORKGROUP.DEL_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.delWorkgroupGroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.DELETE_CODE]({ commit }, code) {
		const params = {
			status: 'disable',
		}
		return new Promise((resolve, reject) => {
			workGroupApi.deleteCode(code, params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 修改成员权限
	[STORE_CONST.WORKGROUP.PATCH_MEMBER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.patchWorkGroupMember(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_CODE_INFO]({ commit }, code) {
		return new Promise((resolve, reject) => {
			workGroupApi.getCodeInfo(code).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取工作组成员管理员
	[STORE_CONST.WORKGROUP.GET_MEMBER_ADMIN]({ commit }, id) {
		return new Promise((resolve, reject) => {
			workGroupApi.getWorkgroupMemberAdmin(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.MODIFY_CODE]({ commit }, obj) {
		return new Promise((resolve, reject) => {
			workGroupApi.modifyCode(obj.code, obj.data).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.SET_PROJECT_DEFAULT_NAME]({ commit }, obj) {
		return new Promise((resolve, reject) => {
			workGroupApi.setProjectDafaultName(obj.project_resource_id, obj.data).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	[STORE_CONST.WORKGROUP.GET_CODE_VERSION]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getCodeVersion(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取工作组资源 在线连接列表
	[STORE_CONST.WORKGROUP.GET_WORKGROUP_RESOURCE_ONLINE_CONNECTS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getResourceOnlineConnects(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取lite连接信息
	[STORE_CONST.WORKGROUP.GET_LITE_CONNECT_INFO]({ commit }, data) {
		return new Promise((resolve, reject) => {
			workGroupApi.getLiteConnectInfo(data).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取协助连接信息
	[STORE_CONST.WORKGROUP.GET_ASSIST_INFO]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getAssistInfo(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取主链接的shadow连接
	[STORE_CONST.WORKGROUP.GET_SHADOW_CONNECT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getShadowConnect(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 创建shadow连接
	[STORE_CONST.WORKGROUP.GET_CSOS_SHADOW]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getCsosShadow(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err)
				},
			)
		})
	},
	// 轮询csos 连接
	[STORE_CONST.WORKGROUP.QUERY_CSOS_CONNECT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.queryCsosConnect(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// SQL语法校验
	[STORE_CONST.WORKGROUP.VERIFY_SQL]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.verifySQL(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取成员下所在工作组列表
	[STORE_CONST.WORKGROUP.GET_ACCOUNT_WORKGROUP_LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.getAccountWorkgroupList(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},

	// 添加成员下工作组
	[STORE_CONST.WORKGROUP.ADD_ACCOUNT_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.addAccountWorkgroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},

	// 删除成员下工作组
	[STORE_CONST.WORKGROUP.DEL_ACCOUNT_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.deleteAccountWorkgroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},

	// 获取群组下的工作组列表
	[STORE_CONST.WORKGROUP.GET_WORKGROUP_LIST_BY_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi
				.getWorkGroupListByGroup(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// 添加群组下的工作组
	[STORE_CONST.WORKGROUP.ADD_GROUP_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.addGroupWorkgroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除群组下的工作组
	[STORE_CONST.WORKGROUP.DEL_GROUP_WORKGROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			workGroupApi.deleteGroupWorkgroup(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
}

const getters = {
	workgroup: (state) => {
		return state.workgroup
	},
}

export default {
	state,
	mutations,
	actions,
	getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/workgroup.js